import Header from 'components/Header/Header';
import JobsTable from 'components/JobsTable/JobsTable';
import { AppContext } from 'contexts/AppContext';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

export default function JobsTablePage() {
  const { clusterName } = useContext(AppContext);

  return (
    <>
      <Header>
        <FormattedMessage id="header.jobsOfCluster" values={{ clusterName }} />
      </Header>
      <JobsTable />
    </>
  );
}
